(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opalo-black-friday-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('opalo-bf-strip')) {
    customElements.define('opalo-bf-strip', class extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.opalo-bf-strip__toggle');
        if (!this.toggleButton || this.toggleHandler) return;
        this.toggleHandler = () => {
          const paused = this.classList.toggle('is-paused');
          this.toggleButton.setAttribute('aria-pressed', String(paused));
          this.toggleButton.setAttribute('aria-label', paused ? this.toggleButton.dataset.resumeLabel : this.toggleButton.dataset.pauseLabel);
        };
        this.toggleButton.addEventListener('click', this.toggleHandler);
      }
      disconnectedCallback() {
        if (this.toggleButton && this.toggleHandler) this.toggleButton.removeEventListener('click', this.toggleHandler);
        this.toggleHandler = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
